import { utils } from '@yola/ws-sdk';
import { breakpointKeys } from 'src/js/modules/element-settings/constants/breakpoints';
import { targetAttributes } from 'src/js/modules/element-settings/constants/target-attributes';
import settingIds from '../../constants/setting-ids';
import { horizontalGapTargets } from '../../constants/targets';

const RESTRICTED_VALUE = 30;
const FALLBACK_VALUE = '30px';

const convert = (attributeValue) => {
  let value = FALLBACK_VALUE;

  if (attributeValue !== true && attributeValue !== '' && attributeValue != null) {
    const parsedValue = parseFloat(attributeValue);

    if (utils.isNumeric(parsedValue)) {
      value = `${parsedValue}px`;
    }
  }

  const values = { [breakpointKeys.DEFAULT]: value };

  if (parseFloat(value) > RESTRICTED_VALUE) {
    values[breakpointKeys.MAX_XL] = `${RESTRICTED_VALUE}px`;
  }

  return values;
};

export default [
  {
    scope: settingIds.ALL_COLUMNS,
    attribute: targetAttributes.COLUMN_GAP,
    classes: horizontalGapTargets,
    convert,
  },
];
